//@ts-nocheck
import {
  addDays,
  differenceInCalendarDays,
  differenceInHours,
  getYear,
  parse,
  setDate,
} from "date-fns";
import {
  applySnapshot,
  cast,
  flow,
  getEnv,
  getParent,
  getSnapshot,
  types,
} from "mobx-state-tree";
import { ITutorSubject } from ".";
import { AdapterType } from "../adapter";
import { parseStringForTriggers } from "../components/form-elements/ExpandingTextArea/hook";
import QuizStore from "../tutor-revamp/quizzes/quizStore";
import { UploadStore } from "./upload-store";
import { intersection } from "./utils";

const CertificationStore = types.model("CertificationStore", {
  name: types.optional(
    types.union(types.maybe(types.string), types.maybeNull(types.string)),
    ""
  ),
  institution: types.optional(
    types.union(types.maybe(types.string), types.maybeNull(types.string)),
    ""
  ),
});

export const SUBJECT_EDIT_STEPS = {
  PREFERENCES: "Preferences",
  HEADING: "Headline",
  DESCRIPTIONS: "Description",
  PRICING: "Pricing",
  ADDITIONAL_STUDENT_PRICING: "Additional Students",
  CERTIFICATIONS: "Certifications",
  IMAGES: "Image",
  REQUIREMENTS: "Requirements",
  PREVIEW: "Preview",
};

const SubjectImage = types.model("SubjectImage", {
  id: types.string,
  url: types.string,
  caption: types.maybeNull(types.string),
  // isNew: types.optional(types.boolean, true),
});
const TestProof = types.model("TestProof", {
  id: types.optional(types.string, ""),
  url: types.optional(types.string, ""),
});

const ExamSpecialtyPreference = types.model("ExamSpecialtyPreference", {
  key: types.optional(types.string, ""),
  value: types.optional(types.array(types.string), []),
});

const TeachingPreferenceStore = types
  .model("TeachingPreferenceStore", {
    key: types.optional(types.string, ""),
    type: types.optional(types.string, ""),
    value: types.union(
      types.optional(types.string, ""),
      types.optional(types.array(types.string), []),
      types.optional(TestProof, {})
    ),
  })
  .views((self) => {
    return {
      get test_results() {
        let value = {};
        if (self.key === "test_results") {
          value = {};
        }
        return value;
      },
    };
  })
  .actions((self) => {
    return {
      update(key, value) {
        self.value = Array.isArray(value) ? cast(value) : value;
        self.key = key;
      },
    };
  });

const PriceSuggestion = types.model("PriceSuggestion", {
  minimum: types.maybe(types.union(types.number, types.string)),
  recommended: types.union(types.string, types.number),
  maximum: types.maybe(types.union(types.string, types.number)),
});

export const TutorSubject = types
  .model("TutorSubjectStore", {
    id: types.optional(types.number, 0),
    sittingsCount: types.optional(types.number, 0),
    name: types.optional(types.string, ""),
    title: types.optional(types.string, ""),
    description: types.optional(types.string, ""),
    teachingStyle: types.optional(types.string, ""),
    teachingRequirements: types.optional(types.array(types.string), []),
    preliminaryQuestions: types.optional(types.array(types.string), []),
    preferences: types.optional(types.array(TeachingPreferenceStore), []),
    trackRecords: types.optional(types.string, ""),
    category: types.optional(types.string, ""),
    subcategory: types.optional(types.string, ""),
    exhibitions: types.optional(types.array(SubjectImage), []),
    status: types.optional(
      types.enumeration("status", [
        "active",
        "pending",
        "in-progress",
        "denied",
        "not-started",
      ]),
      "not-started"
    ),
    hourlyRate: types.union(
      types.optional(types.string, ""),
      types.optional(types.number, 0)
    ),
    validPrice: types.optional(types.boolean, false),
    extraStudents: types.optional(types.number, 0),
    agree: types.optional(types.boolean, false),
    canTakeTest: types.optional(types.boolean, false),
    dateDenied: types.maybeNull(types.string),
    totalAttempts: types.optional(types.number, 0),
    isTestable: types.optional(types.boolean, false),
    attemptedTest: types.optional(types.boolean, false),
    finishedTest: types.optional(types.boolean, false),
    passedTest: types.optional(types.boolean, false),
    isCurrent: types.optional(types.boolean, true),
    quizScore: types.optional(types.string, ""),
    certifications: types.optional(types.array(CertificationStore), []),
    loading: types.optional(types.boolean, false),
    quizStore: types.optional(QuizStore, {}),
    uploadStore: types.optional(UploadStore, {}),
    // _priceSuggestion: types.maybe(PriceSuggestion),
    firstTestTime: types.maybeNull(types.string),
  })
  .views((self) => {
    let { adapter } = getEnv<{ adapter: AdapterType }>(self);
    return {
      get priceSuggestion() {
        return null;
        // return self._priceSuggestion
        //   ? getSnapshot(self._priceSuggestion)
        //   : undefined;
      },
      get daysLeftToRetry() {
        let result;
        if (self.dateDenied) {
          let dateRequired = addDays(parse(self.dateDenied), 1);
          // let dateRequired = setDate(parse(self.dateDenied), 30);
          result = differenceInCalendarDays(
            new Date(parse(dateRequired)),
            new Date()
          );
        } else {
          result = -1;
        }
        console.log(result);
        return result;
      },
      get withinTimeWindow() {
        if (self.firstTestTime) {
          let hoursElapsed = differenceInHours(
            new Date(),
            new Date(parse(self.firstTestTime))
          );
          return hoursElapsed >= 0 && hoursElapsed <= 48;
        } else {
          return true;
        }
      },
      similarityCheck(other_skills: string[], field: string) {
        return other_skills.some((sk) => {
          let _self: any = self;
          return sk.toLowerCase().includes(_self[field].toLowerCase());
        });
      },
      failedSkillCheck(failed_skills: string[], field: string) {
        return failed_skills.some((sk) => {
          let _self: any = self;
          return _self[field].toLowerCase().includes(sk.toLowerCase());
        });
      },
      get photos() {
        return self.exhibitions.map((o) => ({
          id: o.id,
          preview: o.url,
          caption: o.caption,
        }));
      },

      checkPreferenceType(preferenceValue) {
        let isComplex = false;
        if (preferenceValue.find((val) => val.includes(":"))) {
          isComplex = true;
        }
        return isComplex;
      },
      get uploadKey() {
        let f = self.preferences.filter((o) => {
          let y: any = o.value;
          return y?.url;
        });
        if (f.length > 0) {
          return f[0].key;
        }
      },
      get defaultPreferenceValues() {
        let defaultPreference = {};
        self.preferences.forEach((preference) => {
          if (Array.isArray(preference.value)) {
            // check if it is complex or simple
            if (preference.value.length > 0) {
              let splitByDelimiter = preference.value.map((o) => {
                let rr = o.split(":");
                if (rr.length === 1) {
                  return o;
                }
                let x = rr[1].split(",").map((u) => u.trim());
                return {
                  heading: rr[0],
                  options: preference.type === "number" ? x[0] : x,
                };
              });
              if (typeof splitByDelimiter[0] === "string") {
                defaultPreference[preference.key] = splitByDelimiter;
              } else {
                let v = {};
                splitByDelimiter.forEach((y: any) => {
                  v[y.heading] = y.options;
                });
                defaultPreference[preference.key] = v;
              }
            } else {
              defaultPreference[preference.key] = getSnapshot(preference.value);
            }
          } else {
            let r: any = preference.value;
            if (r?.url) {
              defaultPreference[preference.key] = [
                { name: r.public_id, public_id: r.public_id, url: r.url },
              ];
            } else {
              if (typeof preference.value === "string") {
                defaultPreference[preference.key] = preference.value;
              } else {
                defaultPreference[preference.key] = JSON.stringify(
                  preference.value
                );
              }
            }
          }
          // defaultPreference = {
          //   ...defaultPreference,
          //   [preference.key]:
          //     typeof preference.value === "string"
          //       ? preference.value
          //       : preference.value.toJSON(),
          // };
        });
        return defaultPreference;
      },
      preferenceQuestions(parent: any) {
        let { buildPreferences } = getEnv(self);
        // const parent: any = getParent(self, 2);
        // const subject = parent.tuteriaSubjects.find(
        //   ({ name }) => name === self.name
        // );
        const subject = parent.tuteriaSubjectForCurrentSubject;
        return subject ? buildPreferences(subject) : [];
      },
      fieldValue(key: string | string[]): any {
        if (Array.isArray(key)) {
          let result = {};
          key.forEach((k) => {
            result[k] = getSnapshot(self)[k];
          });
          return result;
        } else {
          return { [key]: getSnapshot(self)[key] };
        }
      },
      subjectDescription(): any {
        const subjectDescriptionTrio = [
          "description",
          "trackRecords",
          "teachingStyle",
        ];
        const result = {};
        subjectDescriptionTrio.forEach(
          (item) =>
            (result[item] =
              getSnapshot(self)[item] || adapter.loadSubjectDescription(item))
        );
        return result;
      },
      get initialFormData() {
        return getSnapshot(self);
      },
      preferenceCompleted(parent: any) {
        return this.isSectionComplete("preference", parent);
      },
      isSectionComplete(
        section: "preference" | "about_subject" | "pricing" | "requirements",
        parent?: any
      ) {
        let _self = this;
        let options = {
          preference: () => {
            let preferences = _self
              .preferenceQuestions(parent)
              .filter((o) => o.required);
            let preferenceValues = _self.defaultPreferenceValues;
            let populated = preferences.map((j) => preferenceValues[j.name]);
            let complete = populated.every(Boolean);
            console.log({ complete, x: populated.length });
            return populated.length > 0 && complete;
          },
          about_subject: () => !!(self.title && self.description),
          pricing: () => {
            return Boolean(self.hourlyRate) && Boolean(self.extraStudents);
          },
          requirements: () => false,
        };
        return options[section]();
      },
      isFormStepInValid(
        step:
          | "headline"
          | "description"
          | "pricing"
          | "additional_students"
          | "requirements"
          | "preference",
        canDisplay: boolean
      ) {
        let hourlyRate: any = self.hourlyRate;
        let extraStudents: any = self.extraStudents;
        let options = {
          headline: !self.title,
          description: !self.description,
          pricing: parseFloat(hourlyRate) <= 0,
          additional_students: parseFloat(extraStudents) <= 0,
          requirements: false,
          preference: false,
        };
        return canDisplay && options[step];
      },
      get canSubmitSubject() {
        let v: any = self;
        return [
          "headline",
          "description",
          "pricing",
          "additional_students",
          "requirements",
          "preference",
        ].every((o) => !v.isFormStepInValid(o, true));
      },
      get serverFormat() {
        return {
          skill: {
            name: self.name,
          },
          heading: self.title,
          description: self.description,
          certification: self.certifications.map((o) => ({
            award_name: o.name,
            award_institution: o.institution,
          })),
          other_info: {
            teachingStyle: self.teachingStyle,
            trackRecords: self.trackRecords,
            teachingRequirements: getSnapshot(self.teachingRequirements),
            preliminaryQuestions: getSnapshot(self.preferences),
            agree: self.agree,
            extraStudents: self.extraStudents,
            totalAttempts: self.totalAttempts,
            firstTestTime: self.firstTestTime,
            status: self.status,
            dateDenied:
              self.status === "denied"
                ? self.dateDenied || new Date().toISOString()
                : undefined,
          },
          exhibitions: self.exhibitions.map((o) => ({
            image: o.id,
            caption: o.caption,
          })),
          price: self.hourlyRate,
        };
      },
    };
  })
  .actions((self) => {
    let { adapter } = getEnv<{ adapter: AdapterType }>(self);
    function preferenceSubmission(v) {
      const preferences = [];
      // const category = self.category;
      // if (category === "Academics") {
      //   for (let [key, value] of Object.entries(v)) {
      //     if (key === "exam_speciality") {
      //       const specialities = []
      //       for (let [type, speciality] of Object.entries(value)) {
      //         if (speciality.length) {
      //           specialities.push(type + ":" + speciality.join(","))
      //         }
      //       }
      //       preferences.push({ key, value: specialities })
      //       continue
      //     }
      //     preferences.push({ key, value })
      //   }
      // }

      // if (category === "Test Prep") {
      //   for (let [key, value] of Object.entries(v)) {
      //     if (key === "test_results") {
      //       const results = []
      //       for (let [test, result] of Object.entries(value)) {
      //         if (result) {
      //           results.push(test + ":" + result)
      //         }
      //       }
      //       preferences.push({ key, value: results })
      //       continue
      //     }
      //     if (key === "test_results_verification") {
      //       if (value.length) {
      //         preferences.push({ key, value: { url: value[0].url, id: value[0].public_id } })
      //       }
      //       continue
      //     }
      //     preferences.push({ key, value })
      //   }
      // }

      // if (category === "Music") {
      //   for (let [key, value] of Object.entries(v)) {
      //     preferences.push({ key, value })
      //   }
      // }

      // if (category === "Languages") {
      //   for (let [key, value] of Object.entries(v)) {
      //     preferences.push({ key, value })
      //   }
      // }
      for (let [key, value] of Object.entries(v)) {
        if (
          typeof value === "object" &&
          !Array.isArray(value) &&
          value !== null
        ) {
          let result = [];
          for (let [k, v] of Object.entries(value)) {
            if (Array.isArray(v)) {
              v.length && result.push(k + ":" + v.join(","));
            } else {
              v && result.push(k + ":" + v);
            }
          }
          preferences.push({ key, value: result });
        } else if (Array.isArray(value) && value[0]?.url) {
          preferences.push({ key, value: value[0] });
        } else {
          preferences.push({ key, value });
        }
      }
      applySnapshot(self, { ...getSnapshot(self), preferences });
      return preferences;
    }
    function headlineSubmission(v) {
      self.title = v.title;
      return { title: v.title };
    }
    function descriptionSubmission({ preferences, ...v }) {
      applySnapshot(self, { ...getSnapshot(self), ...v });
      // preferenceSubmission(preferences);
      return {
        title: self.title,
        description: self.description,
        trackRecords: self.trackRecords,
        teachingStyle: self.teachingStyle,
        preferences,
      };
    }
    function pricingSubmission(v) {
      self.hourlyRate = v.hourlyRate;
      self.validPrice = v.validPrice;
      return v;
    }
    function extraStudentsubmission(v) {
      self.extraStudents = v.extraStudents || v.extraStudentsDiscount;
      return v;
    }
    function imageSubmission(v) {
      return getSnapshot(self.exhibitions);
    }
    function requirementSubmission(v) {
      applySnapshot(self, { ...getSnapshot(self), ...v });
      return {
        teachingRequirements: v.teachingRequirements,
      };
    }
    function certificationSubmission(values) {
      applySnapshot(self, { ...getSnapshot(self), ...values });
      return values;
    }

    function updateSubjectStatus(isLiteTutor?: boolean) {
      let subjectStore = getParent(self, 2);
      self.status = "pending";
      if (isLiteTutor) {
        self.status = "active";
      }
      if (["in-progress", "pending"].includes(self.status)) {
        // update to pending instead of waiting for server call when some details are populated
        // if (
        //   self.title &&
        //   self.description &&
        //   self.extraStudents > 0 &&
        //   self.hourlyRate > 0 &&
        //   self.isSectionComplete("preference", subjectStore)
        // ) {
        //   self.status = "active";
        // }
      }
    }

    const onSubmit = flow(function* onUpdateProfile(
      key: string,
      value: any,
      isLiteTutor
    ) {
      let options = {
        [SUBJECT_EDIT_STEPS.PREFERENCES]: preferenceSubmission,
        [SUBJECT_EDIT_STEPS.DESCRIPTIONS]: descriptionSubmission,
      };
      let result: any = options[key](value);
      try {
        self.loading = true;
        updateSubjectStatus(isLiteTutor);
        yield adapter.updateTutorSubjectInfo(key, self.serverFormat, self.id);
        self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    const buildQuiz = flow(function* buildQuiz(
      subjectInfo,
      subjectsQuizzes: any[]
    ) {
      if (!self.firstTestTime) {
        self.firstTestTime = new Date().toISOString();
        self.totalAttempts = 1;
      } else {
        self.totalAttempts = self.totalAttempts + 1;
      }
      try {
        self.loading = true;
        let namesOnly = subjectsQuizzes.map((o) => o.name);
        let _quizData = yield adapter.buildQuizToTake({
          ...subjectInfo,
          subjects: subjectInfo.subjects.filter((o) =>
            namesOnly.includes(o.name)
          ),
        });
        self.quizStore.initializeQuiz(_quizData[0], subjectsQuizzes);
        self.loading = false;
        return _quizData[1];
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });

    const beginQuiz = flow(function* beginQuiz(subjectInfo) {
      try {
        // yield adapter.updateTutorSubjectInfo("", self.serverFormat, self.id);
        yield adapter.beginQuiz(
          { subjects: [subjectInfo.name] },
          { skill_id: self.id, payload: self.serverFormat }
        );
      } catch (error) {
        throw error;
      }
    });

    const onDeletePhoto = flow(function* onDeletePhoto(photo) {
      try {
        yield adapter.deleteSubjectImage(photo.id);
      } catch (error) {
        throw error;
      }
    });

    const onRefresh = flow(function* onRefresh(subjectsQuizzes) {
      try {
        yield adapter.createQuizFromSheet(subjectsQuizzes);
      } catch (error) {
        throw error;
      }
    });

    const saveOnBlur = (name, value) => {
      adapter.saveOnBlur(name, value);
    };

    const updatePriceAgreement = () => {
      self.agree = true;
    };

    // const getPriceSuggestion = flow(function* fetchPriceSuggestion() {
    //   // if (!self._priceSuggestion) {
    //   //   let result = yield adapter.getPriceSuggestion(self.name);
    //   //   self._priceSuggestion = PriceSuggestion.create(result);
    //   // }
    // });
    const handleQuizSubmission = flow(function* handleQuizSubmission(
      quizzes: any,
      parent
    ) {
      let response = yield self.quizStore.handleSubmission(quizzes);
      // if (parent){
      //   yield parent.
      // }
      return response;
    });

    const updateQuizAttempts = flow(function* updateQuizAttempts() {
      try {
        yield adapter.updateTutorSubjectInfo("", self.serverFormat, self.id);
      } catch (error) {
        throw error;
      }
    });

    return {
      // getPriceSuggestion,
      handleQuizSubmission,
      buildQuiz,
      onSubmit,
      onDeletePhoto,
      beginQuiz,
      onRefresh,
      saveOnBlur,
      updatePriceAgreement,
      updatePreference(key, value) {
        let existing = self.preferences.find((o) => (o.key = key));
        if (existing) {
          existing.update(key, value);
        } else {
          self.preferences.push({ key, value });
        }
      },
      initialize(subjectValue: any) {
        applySnapshot(self, { ...getSnapshot(self), ...subjectValue });
        this.initializeUpload();
      },
      initializeUpload() {
        if (self.uploadKey) {
          applySnapshot(self.uploadStore, {
            files: self.defaultPreferenceValues[self.uploadKey],
          });
          // self.uploadStore = UploadStore.create({
          //   files: self.defaultPreferenceValues[self.uploadKey],
          // });
        }
      },
      updateSubjectForm(values) {
        applySnapshot(self, { ...self, ...values });
      },

      setTeachingRequirements(value) {
        self.teachingRequirements.push(value);
      },
      updateTestStatus(passed: boolean) {
        if (passed) {
          self.status = "in-progress";
          self.canTakeTest = false;
        } else {
          self.status = "denied";
          self.dateDenied = new Date().toISOString();
          // self.totalAttempts = self.totalAttempts + 1;
        }
      },
      updateQuizAttempts,
      clearQuizStore() {
        self.quizStore = cast({});
      },
    };
  });

const Subject = types.model("Subject", {
  name: types.optional(types.string, ""),
});

export const FilterStore = types.model("FilterTerm", {
  category: types.optional(types.string, ""),
  subcategory: types.optional(types.string, ""),
  status: types.optional(types.string, ""),
});

const TestSubject = types.model("TestSubject", {
  name: types.optional(types.string, ""),
  url: types.optional(types.string, ""),
  test_name: types.optional(types.string, ""),
  pass_mark: types.maybeNull(types.number),
  test_sheet_id: types.maybeNull(types.union(types.number, types.string)),
});

export const TuteriaSubject = types
  .model("TuteriaSubject", {
    slug: types.optional(types.string, ""),
    name: types.optional(types.string, ""),
    category: types.optional(types.string, ""),
    subcategory: types.optional(types.array(types.string), []),
    subjects: types.optional(types.array(TestSubject), []),
    pass_mark: types.maybeNull(types.number),
    hire_score: types.optional(types.number, 0),
    modules: types.optional(types.array(types.string), []),
    useModules: types.optional(types.boolean, false),
    duration: types.optional(
      types.union(types.maybe(types.number), types.maybeNull(types.number)),
      0
    ),
    questionCount: types.optional(types.number, 30),
    baseRate: types.optional(types.number, 0),
  })
  .views((self) => {
    return {
      get preferenceOptions() {
        if (self.modules.length > 0) {
          // if (self.useModules) {
          return self.modules;
        }
        // }
        const subjects = [];
        self.subjects.forEach((subject) => {
          if (subject.name !== self.name) {
            subjects.push(subject.name);
          }
        });
        if (subjects.length > 0) {
          return subjects;
        }
        return [];
      },
    };
  });
export type SSubjectSelectionType = any[];

export const TuteriaGroup = types
  .model("TuteriaGroup", {
    title: types.string,
    description: types.string,
    subjectGroups: types.optional(types.array(types.string), []),
    type: types.optional(
      types.enumeration(["generic", "specialized"]),
      "generic"
    ),
  })
  .views((self) => {
    return {
      groupScore() {
        return this.subjects
          .map((o) => o.hire_score)
          .reduce((a, b) => a + b, 0);
      },
      // get subjects() {
      //   let parent: any = getParent(self, 2);
      //   const foundSubjects = self.subjectGroups.map((o) =>
      //     parent.tuteriaSubjects.find((u) => u.name === o)
      //   );
      //   return foundSubjects;
      // },
    };
  });

const JobSubject = types
  .model("JobSubject", {
    suggested: types.optional(types.string, ""),
    subject: types.optional(types.string, ""),
    skill_related: types.optional(types.array(types.string), []),
    implied: types.optional(types.maybeNull(types.string), ""),
  })
  .views((self) => {
    return {
      qualifiedSubject(tutorSubjects: ITutorSubject[]) {
        const found = tutorSubjects.filter((o) => {
          // if(o.name == self.suggested){
          //   return true
          // }
          return (
            self.skill_related.includes(o.name) &&
            // !["denied", "suspended"].includes(o.status)
            !["suspended"].includes(o.status)
          );
        });
        if (found.length > 0) {
          const similar = found.find((u) => u.name === self.suggested);
          return similar || found[0];
        }
        return null;
      },
    };
  });

export const SubjectStore:any = types
  .model("SubjectStore", {
    selectedSubjects: types.optional(types.array(Subject), []),
    quizSubjects: types.optional(types.array(types.string), []),
    testSubject: types.optional(types.string, ""),
    searchTerm: types.optional(types.string, ""),
    tutorSubjects: types.optional(types.array(TutorSubject), []),
    filterTerms: types.optional(FilterStore, {
      category: "",
      subcategory: "",
      status: "",
    }),
    currentSubjectId: types.maybeNull(types.number),
    loading: types.optional(types.boolean, false),
    hasUpdatedPrice: types.optional(types.boolean, false),
    hourRate: types.optional(types.number, 0),
    error: types.optional(types.string, ""),
    defaultTabIndex: types.optional(types.number, 0),
    tuteriaSubjects: types.optional(types.array(TuteriaSubject), []),
    groups: types.optional(types.array(TuteriaGroup), []),
    currentGroupId: types.optional(types.string, ""),
    selectedSubjectGroups: types.optional(types.array(types.string), []),
    jobStore: types.optional(types.array(JobSubject), []),
  })
  .views((self) => {
    return {
      get pricingData() {
        return {
          withholdingTax: 5,
          currency: "₦",
        };
      },
      get earningPercentage() {
        let { adapter } = getEnv<{ adapter: AdapterType }>(self);
        return adapter.getEarningPercentage();
      },
      get priceAgreement() {
        return self.tutorSubjects.some((o) => o.agree);
      },
      customValidation(field: string) {
        let existingSubjects = self.tutorSubjects.filter(
          (o) => o.id !== self.currentSubjectId
        );
        let failedSubjects = existingSubjects.filter(
          (o) => o.status === "denied"
        );
        let errors = [];
        if (self.currentSubjectId) {
          // let failed = this.currentSubject.failedSkillCheck(
          //   failedSubjects.map((o) => o.name),
          //   field
          // );
          // // let similar = this.currentSubject.similarityCheck(
          // //   existingSubjects.map((o) => o[field] || "")
          // // );
          // if (failed) {
          //   errors.push(`Failed subjects can not be in ${field}`);
          // }
          // if (similar) {
          //   errors.push(`Cannot have subjects with similar descriptions`);
          // }
          let triggers: any = {};
          if (failedSubjects.length > 0) {
            triggers.failedSkills = {
              triggers: failedSubjects.map((o) => o.name.toLowerCase()),
              isActive: true,
              prompt: "Sorry! Can't add a subject that was denied",
            };
          }
          console.log({ triggers });
          return triggers;
        }
      },
      availableSubjects(currentId) {
        return self.tutorSubjects
          .filter((o) => ["active", "pending"].includes(o.status))
          .filter((o) => o.id !== currentId)
          .map((o) => ({
            name: o.name,
            description: o.description,
            teachingStyle: o.teachingStyle,
            trackRecords: o.trackRecords,
          }));
      },
      get completed() {
        let uu = self.tutorSubjects.map((o) => o.status);
        let result =
          self.tutorSubjects.length > 0 &&
          self.tutorSubjects.filter((o) =>
            ["active", "pending"].includes(o.status)
          ).length > 0;
        return result;
      },
      get allCombinedSubjects() {
        /*
          This view combines tutor subjects and all tuteria subjects
          to be added to subject creation page,
        */
        return self.tuteriaSubjects.map((o) => {
          return {
            ...o,
            subjects: o.subjects.map((j) => {
              let tutorSubject = self.tutorSubjects.find(
                (u) => u.name === j.name
              );
              return {
                ...j,
                status: tutorSubject?.status,
              };
            }),
          };
        });
      },
      get mappedSubjects() {
        let result = [];
        let categories = Array.from(
          new Set(self.tuteriaSubjects.map((o) => o.category))
        );
        categories.forEach((category) => {
          let ist = self.tuteriaSubjects.filter((o) => o.category === category);
          let _subCategories = Array.from(
            new Set(ist.map((o) => o.subcategory).flat())
          );
          let subCategoryWithSubjects = _subCategories.map((y: any) => {
            let subjects = ist
              .filter((o) => o.subcategory.includes(y))
              .map((o) => {
                let tutorSubject = self.tutorSubjects.find(
                  (j) => j.name === o.name
                );

                return {
                  ...o,
                  status: tutorSubject?.status,
                };
              });
            // .flat();
            return { title: y, subjects };
          });
          result.push({ category, subcategories: subCategoryWithSubjects });
        });
        return result;
      },

      get filteredByStatusSubjects() {
        /*
        This view filters all tutor subjects by status
        */
        const filteredTutorSubjects = self.filterTerms.status
          ? self.tutorSubjects.filter(
              (subject) => subject.status === self.filterTerms.status
            )
          : self.tutorSubjects;
        return filteredTutorSubjects;
      },

      get allFilteredSubjects() {
        /*
        This view filters all subjects in the creation page by category.
        This is why it uses the mapped subjects view
        */
        const filteredSubjects = self.filterTerms.category
          ? this.mappedSubjects.filter(
              (subject) => subject.category === self.filterTerms.category
            )
          : this.mappedSubjects;
        return filteredSubjects;
      },

      get nonDeniedSubjects() {
        return this.tutorSubjects.filter(
          (subject) => subject.status !== "denied"
        );
      },
      // get allowedSubjectsToAdd(){

      // },
      get canAddMoreSubjects() {
        const has10orMoreSubjects = self.tutorSubjects.length >= 10;
        const activePending = ["active", "pending"];
        const isAllSubjectsDenied = self.tutorSubjects.every(
          (subject) => subject.status === "denied"
        );
        const noActiveOrPendingSubjects = self.tutorSubjects.every(
          (subject) => !activePending.includes(subject.status)
        );
        const hasIncompleteSubjects =
          self.tutorSubjects.filter(
            (subject) => ![...activePending, "denied"].includes(subject.status)
          ).length > 0;
        const completed6Subjects =
          self.tutorSubjects.filter((subject) =>
            activePending.includes(subject.status)
          ).length >= 6;

        if (has10orMoreSubjects) {
          if (isAllSubjectsDenied) return false;
          if (noActiveOrPendingSubjects) return false;
          if (hasIncompleteSubjects) return false;
          if (!hasIncompleteSubjects && !completed6Subjects) return false;
          return true;
        } else {
          console.log({ selectedSubjects: self.selectedSubjects.length });
          let totalActiveSubjects = self.tutorSubjects.filter((o) =>
            ["active", "pending"].includes(o.status)
          ).length;
          if (totalActiveSubjects > 8) {
            return true;
          }
          return self.tutorSubjects.length + self.selectedSubjects.length < 11;
        }
      },

      get totalSelectedSubjects() {
        let totalSelectedSubjects = [
          ...self.tutorSubjects,
          ...self.selectedSubjects,
        ];
        return Array.from(new Set(totalSelectedSubjects));
      },
      get categories() {
        const categories = this.mappedSubjects.map(
          (subject) => subject.category
        );
        return categories;
      },

      get subcategories() {
        /*
        This view returns all tuteria subcategories
        */
        const subcategories = this.mappedSubjects
          .map((subject) => {
            return subject.subcategories.map((subcategory) => {
              return {
                title: subcategory.title,
                subjects: subcategory.subjects,
              };
            });
          })
          .flat();
        return subcategories;
      },

      get filteredSubcategories() {
        /*
        This view filters all subcategories with subjects by category
        */
        const subcategories = this.allFilteredSubjects
          .map((subject) => {
            return subject.subcategories.map((subcategory) => {
              return {
                title: subcategory.title,
                subjects: subcategory.subjects,
              };
            });
          })
          .flat();
        return subcategories;
      },

      get statusFilters() {
        return [
          "all",
          "active",
          "pending",
          "in-progress",
          "denied",
          "not-started",
        ];
      },

      get currentSubject() {
        const currentSubject = self.tutorSubjects.find(
          (subject) => subject.id === self.currentSubjectId
        );
        return currentSubject;
      },

      get currentGroup() {
        const currentGroup = this.generatedGroups.find(
          (group) => group.title === self.currentGroupId
        );
        return currentGroup;
      },

      get formValues(): SSubjectSelectionType {
        let finalSubjects = this.totalSelectedSubjects.map((subject, index) => {
          if (subject.status) {
            return { ...subject };
          } else {
            return { ...subject, status: "not-started" };
          }
        });
        let tutorSubjects = self.tutorSubjects.map((o) => o.name);
        return finalSubjects.filter((x) => !tutorSubjects.includes(x.name));
        // return finalSubjects;
      },

      searchedSubjects(searchTerm: string) {
        // let allSubjects = [...this.tuteriaSubjects, ...this.tutorSubjects];
        const subjects = this.allCombinedSubjects.filter(
          (subject) =>
            subject.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            subject.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
            subject.subcategory
              .map((o) => o.toLowerCase())
              // .toLowerCase()
              .includes(searchTerm.toLowerCase())
        );
        const foundSubjects = subjects.map((subject) => {
          return {
            ...subject,
            status: subject.subjects.find((subj) => subj.name === subject.name)
              ?.status,
          };
        });
        return foundSubjects;
      },
      getTuteriaSubject(currentSubject: any): any {
        let _self: any = self;
        if (_self.tuteriaSubjects.length > 0) {
          let instance = _self.tuteriaSubjects.find(
            (o) => o.name === currentSubject.name
          );
          if (instance) {
            return getSnapshot(instance);
          }
        }
        return null;
      },
      get tuteriaSubjectForCurrentSubject(): any {
        let _self: any = self;
        let currentSubject = _self.currentSubject;
        if (self.tuteriaSubjects.length > 0) {
          let instance = self.tuteriaSubjects.find(
            (o) => o.name === currentSubject.name
          );
          if (instance) {
            return instance;
          }
        }
        return null;
      },
      get selectedQuizSubjects() {
        const currentTestSubjectData = getSnapshot(self.tuteriaSubjects).find(
          ({ name }) => name === self.testSubject
        );
        return {
          name: self.testSubject,
          subjects: self.quizSubjects.map((item) =>
            currentTestSubjectData.subjects.find(({ name }) => name === item)
          ),
        };
      },

      subjectIsSelected(
        selectedSubjects: Array<{
          name: string;
          // category: string;
          // subcategory: string;
        }>,
        subjectObject: { name: string }
      ) {
        return selectedSubjects.some(
          (item) => subjectObject.name === item.name
          //  && subjectObject.category === item.category &&
          // subjectObject.subcategory === item.subcategory
        );
      },

      cantAddSubject(status) {
        let cantAdd =
          status === "pending" ||
          status === "active" ||
          status === "not-started" ||
          status === "in-progress";
        return cantAdd;
      },

      subcategoryOptions(category) {
        /*
        This view returns the subcategories by category to be used in filtering
        in the subcategory dropdown
        */
        let subcategories = this.mappedSubjects
          .filter((subject) => subject.category === category)
          .map((item) =>
            item.subcategories.map((subcategory) => subcategory.title)
          )
          .flat();
        subcategories = Array.from(new Set(subcategories));
        console.log(subcategories);
        const subcategoryOptions = subcategories.map((subcategory) => {
          return {
            value: subcategory,
            label: subcategory,
          };
        });
        return subcategoryOptions;
      },
      shouldTakeTest(subject) {
        const tuteriaSubject = self.tuteriaSubjects.find(
          ({ name }) => name === subject.name
        );
        return tuteriaSubject
          ? tuteriaSubject.subjects.length > 0 && subject.canTakeTest
          : subject.canTakeTest;
      },
      isSubjectTestable(subject) {
        if (subject) {
          const tuteriaSubject = self.tuteriaSubjects.find(
            ({ name }) => name === subject.name
          );
          const hasTest = tuteriaSubject?.subjects.some(
            (u) => u.test_name !== ""
          );
          return hasTest;
        }
        return false;
      },
      get subjectsLeft() {
        let tutorSubjects = self.tutorSubjects.length;
        let activeSubjects = self.tutorSubjects.filter((o) =>
          ["active", "pending"].includes(o.status)
        ).length;
        if (activeSubjects >= 9) {
          return 20 - activeSubjects;
        }
        return tutorSubjects < 10 ? 10 - tutorSubjects : 0;
      },
      get generatedGroups() {
        const tutorSubjects = new Set(self.tutorSubjects.map((i) => i.name));
        let subjects = self.tutorSubjects
          .filter((u) => ["active"].includes(u.status))
          .map((o) => o.name);
        return self.groups
          .filter((o) => {
            let rr = intersection(o.subjectGroups, subjects);
            return rr.length > 0;
          })
          .map((o) => {
            return {
              ...o,
              subjects: self.tuteriaSubjects
                .filter((i) => o.subjectGroups.includes(i.name))
                .filter((o) => !tutorSubjects.has(o.name)),
            };
          });
      },
      get canProceedToNextPage() {
        const totalSubjectsCount = self.tutorSubjects.length;
        const nonTestableSubjectsCount = self.tutorSubjects.filter(
          (subject) => !this.isSubjectTestable(subject)
        ).length;
        const testableSubjects = self.tutorSubjects.filter((subject) =>
          this.isSubjectTestable(subject)
        );
        const passedSubjects = testableSubjects.filter(
          (subject) =>
            !this.shouldTakeTest(subject) && subject.status !== "denied"
        ).length;
        if (
          nonTestableSubjectsCount > 0 &&
          nonTestableSubjectsCount === totalSubjectsCount
        ) {
          return true;
        }
        return passedSubjects > 0;
      },

      isSelectedSubjectGroup(group) {
        return false;
        // return self.selectedSubjectGroups.includes(group)
      },
      get subjectsRequiredForJob() {
        return self.jobStore
          .map((o) => o.qualifiedSubject(self.tutorSubjects))
          .filter(Boolean);
      },
      get canApplyFoJob() {
        return this.subjectsRequiredForJob.length === self.jobStore.length;
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    // const submitSelectedSubjects = flow(function* submitSelectedSubjects(
    //   selectedSubjectData: Array<any>
    // ) {
    //   self.loading = true;
    //   self.error = "";
    //   try {
    //     let finalSubjects = selectedSubjectData.map((subject, index) => {
    //       if (subject.status) {
    //         return { ...subject };
    //       } else {
    //         return { id: index, ...subject, status: "not-started" };
    //       }
    //     });
    //     const response = yield adapter.submitSelectedSubjects(finalSubjects);
    //     self.tutorSubjects = cast(finalSubjects);
    //     self.selectedSubjects = cast([]);
    //     self.loading = false;
    //     //     return response;
    //   } catch (error) {
    //     self.error = "Error saving subjects";
    //     self.loading = false;
    //   }
    // });

    const deleteSubject = flow(function* deleteSubject() {
      try {
        self.loading = true;
        const response = yield adapter.deleteSubject(self.currentSubjectId);
        self.tutorSubjects = cast(
          self.tutorSubjects.filter((subj) => subj.id !== self.currentSubjectId)
        );
        self.loading = false;
        return response;
      } catch (error) {
        self.error = "Error deleting subject";
        self.loading = false;
      }
    });
    const deleteBulkSubjects = flow(function* deleteBulkSubjects(
      subjects: Array<ITutorSubject>,
      status: string
    ) {
      try {
        self.loading = true;
        const ids = subjects.map((subject) => subject.id);
        const response = yield adapter.deleteBulkSubjects(ids, status);
        self.tutorSubjects = cast(
          self.tutorSubjects.filter((subj) => !ids.includes(subj.id))
        );
        self.loading = false;
        return response;
      } catch (error) {
        self.error = "Error deleting subject";
        self.loading = false;
      }
    });

    function setTestSubject(subject) {
      const foundSubject = self.tuteriaSubjects.find(
        (item) => item.slug === subject
      );
      self.testSubject = foundSubject.name;
    }

    const fetchTutorSubjects = flow(function* fetchTutorSubjects(
      subject?: string
    ) {
      let result = yield adapter.getTutorSubjects();
      self.tuteriaSubjects = cast(result.tuteriaSubjects);
      self.tutorSubjects = cast(result.tutorSubjects);
      if (subject) {
        setTestSubject(subject);
      }
    });

    const updateTutorSubjectInfo = flow(
      function* updateTutorSubjectInfo(values) {
        try {
          self.loading = true;
          let existingData = getSnapshot(self.currentSubject);
          const response = yield adapter.updateTutorSubjectInfo({
            ...existingData,
            ...values,
          });
          self.currentSubject.updateSubjectForm(values);
          self.loading = false;
          return response;
        } catch (error) {
          self.loading = false;
          throw error;
        }
      }
    );
    const uploadSubjectPhotos = flow(function* uploadSubjectPhotos(values) {
      try {
        self.loading = true;
        const response = yield adapter.uploadApiHandler(values);
        self.loading = false;
        return response;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    function getUpdatedStatus(tutorSubjects) {
      return tutorSubjects.map((o) => {
        let tuteriaSubject = self.tuteriaSubjects.find(
          (u) => u.name?.toLowerCase() === o.name?.toLowerCase()
        );
        //in order to avoid doin this on the server, we update the in-progress to not-started on
        // the condition that the tuteria subject from the sheet is testable and the user
        // hasn't taken any test for the subject yet.
        if (o.status === "in-progress" && tuteriaSubject) {
          let hasTest = tuteriaSubject.subjects.some((u) => u.test_name !== "");
          if (hasTest && o.canTakeTest) {
            o.status = "not-started";
          } else {
            if (o.sittingsCount === 0 && hasTest) {
              o.status = "not-started";
            }
          }
        }
        return o;
      });
    }
    function updateSavedSubjects(response) {
      let transformedResponse = getUpdatedStatus(response);
      self.tutorSubjects = cast(transformedResponse);
      self.selectedSubjects = cast([]);
    }
    const saveTutorSelectedSubjects = flow(function* saveTutorSelectedSubjects(
      asyncFunc?: any
    ) {
      try {
        self.loading = true;
        let func = asyncFunc || adapter.saveTutorSubjects;
        console.log("formValues", self.formValues);
        const response = yield func(self.formValues);
        updateSavedSubjects(response);
        self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    const checkSpellingAndSimilarity = flow(function* checkS(
      values: {
        title?: string;
        description?: string;
        teachingStyle?: string;
        trackRecords?: string;
      },
      currentStep: string
    ) {
      let check = [];
      let localErrors: any = {};
      let triggers = self.customValidation("failedSkills");
      let hasError = "";
      let otherSubjects = self.tutorSubjects.filter(
        (o) => o.name != self.currentSubject.name
      );
      let r = (k: any) => {
        return otherSubjects
          .map((o) => ({ key: o.name, value: o[k].trim() }))
          .filter((u) => Boolean(u.value));
      };
      if (currentStep === SUBJECT_EDIT_STEPS.HEADING) {
        hasError = parseStringForTriggers(values.title.trim(), triggers);
        if (hasError) {
          localErrors.title = hasError;
        }
        check.push({
          key: "title",
          text: values.title.trim(),
          other_texts: r("title"),
        });
      }
      if (currentStep === SUBJECT_EDIT_STEPS.DESCRIPTIONS) {
        hasError = parseStringForTriggers(values.description.trim(), triggers);
        if (hasError) {
          localErrors.description = hasError;
        }
        hasError = parseStringForTriggers(
          values.teachingStyle.trim(),
          triggers
        );
        if (hasError) {
          localErrors.teachingStyle = hasError;
        }
        hasError = parseStringForTriggers(values.trackRecords.trim(), triggers);
        if (hasError) {
          localErrors.trackRecords = hasError;
        }
        console.log(!!localErrors.description);
        if (!!localErrors.description === false) {
          if (
            !values.description
              .toLowerCase()
              .includes(self.currentSubject.name.toLowerCase())
          ) {
            localErrors.description = "Description isn't relevant.";
          }
        }
        check.push({
          key: "description",
          text: values.description.trim(),
          other_texts: r("description"),
        });
        if (values.teachingStyle.trim()) {
          check.push({
            key: "teachingStyle",
            text: values.teachingStyle.trim(),
            other_texts: r("teachingStyle"),
          });
        }
        if (values.trackRecords.trim()) {
          check.push({
            key: "trackRecords",
            text: values.trackRecords.trim(),
            other_texts: r("trackRecords"),
          });
        }
      }
      try {
        if (Object.keys(localErrors).length > 0) {
          // eslint-disable-next-line no-throw-literal
          throw { spellCheck: localErrors };
        }
        if (check.length > 0) {
          self.loading = true;
          yield adapter.checkSpellingAndGrammar(check);
          self.loading = false;
        }
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    const saveSelectedSubjectGroups = flow(
      function* saveSelectedSubjectGroups() {
        try {
          self.loading = true;
          const response = yield adapter.saveTutorSubjects(
            self.selectedSubjectGroups.map((item) => {
              return { name: item };
            })
          );
          self.tutorSubjects = cast(response);
          self.loading = false;
        } catch (error) {
          self.loading = false;
          throw error;
        }
      }
    );
    function setFilterTerm(filter: string, key: string) {
      if (filter === "all") {
        self.filterTerms.status = "";
      } else {
        self.filterTerms[key] = filter;
      }
    }
    function setDefaultTabIndex({
      subcategoryFilter,
      reset = false,
    }: {
      subcategoryFilter?: string;
      reset?: boolean;
    }) {
      if (reset) {
        self.defaultTabIndex = 0;
      } else {
        const index = self.filteredSubcategories.findIndex(
          (subcategory) => subcategory.title === subcategoryFilter
        );
        self.defaultTabIndex = index;
      }
    }
    return {
      // submitSelectedSubjects,
      checkSpellingAndSimilarity,
      saveTutorSelectedSubjects,
      saveSelectedSubjectGroups,
      deleteSubject,
      deleteBulkSubjects,
      setFilterTerm,
      setTestSubject,
      fetchTutorSubjects,
      updateTutorSubjectInfo,
      uploadSubjectPhotos,
      initializeTutorSubjects(result: {
        tuteriaSubjects: any[];
        tutorSubjects: any[];
        groups: any[];
        jobSubjects: any[];
      }) {
        self.tuteriaSubjects = cast(result.tuteriaSubjects);
        self.tutorSubjects = cast(result.tutorSubjects);
        self.groups = cast(result.groups || []);
        self.jobStore = cast(result.jobSubjects || []);
      },
      onSubcategoryChange(subcategory: string) {
        if (subcategory === "") {
          setFilterTerm("", "subcategory");
          setDefaultTabIndex({ reset: true });
        } else {
          setFilterTerm(subcategory, "subcategory");
          setDefaultTabIndex({
            subcategoryFilter: self.filterTerms.subcategory,
          });
        }
      },
      onCategoryChange(category: string) {
        setFilterTerm(category, "category");
        let u: any = self;
        let subCategories: any = u.subcategoryOptions(category)[0];
        // this.onSubcategoryChange(subCategories.value);
        setDefaultTabIndex({ reset: true });
      },
      onSubjectSubmit(newTutorSubjects = []) {
        self.tutorSubjects = cast(newTutorSubjects);
        self.selectedSubjects = cast([]);
      },
      selectSubject(subject: { name: string }) {
        self.error = "";
        if (self.subjectIsSelected(self.selectedSubjects, subject)) {
          self.selectedSubjects = cast(
            self.selectedSubjects.filter((x) => x.name !== subject.name)
          );
        } else {
          self.selectedSubjects.push({
            name: subject.name,
          });
        }
      },
      archiveSubject(subject) {
        console.log(subject);
      },
      clearSelectedSubjects() {
        self.selectedSubjects = cast([]);
      },
      // setSearchTerm(val: string) {
      //   self.searchTerm = val;
      // },
      setQuizSubjects(subjects: Array<any>) {
        self.quizSubjects = cast(subjects);
      },
      setError(errorMessage: string) {
        self.error = errorMessage;
      },
      setCurrentSubjectId(id) {
        self.currentSubjectId = id;
        self.currentSubject.initializeUpload();
      },
      setCurrentGroup(currentGroupTitle: string) {
        self.currentGroupId = currentGroupTitle;
      },
      selectSubjectGroups(values) {
        self.selectedSubjectGroups = cast(values);
      },
      saveSubject(id) {
        const foundTutorSubject =
          self.tutorSubjects.find((subject) => subject.id === id) || {};
        adapter.saveSubject(id, foundTutorSubject);
      },
    };
  });
